// Gốc API lấy từ .env (REACT_APP_API_URL), vd local: http://169-ss-bu3/api
const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

export const URL_API = {
  LOGIN: `${API_URL}/login`,
  LOGOUT: `${API_URL}/logout`,
  CHECK: `${API_URL}/checkin/check`,
  CONFIRM: `${API_URL}/checkin/confirm`,
};
